<!-- src/app/companies/company-card/company-card.component.html -->
<div
  class="relative border rounded-2xl overflow-hidden bg-white flex flex-col shadow-xs transition-all duration-150 hover:shadow-md h-full"
  [class]="featured()
    ? 'border-amber-300 hover:border-amber-400'
    : 'border-gray-200 hover:border-gray-300'"
>

  <!-- Featured Pill -->
  @if (featured()) {
    <span class="absolute top-2 left-2 z-10 inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700">
      <mat-icon svgIcon="star" class="size-3! min-w-0! text-amber-400 [&_svg]:fill-amber-400!" aria-hidden="true" />
      Featured
    </span>
  }

  <!-- Logo -->
  <a
    [routerLink]="['/companies', slug()]"
    class="flex items-center justify-center h-44 p-2 bg-white border-b border-gray-100 no-underline"
  >
    @if (imageUrl()) {
      <img
        [src]="imageUrl()"
        [alt]="company().name + ' logo'"
        class="max-w-full max-h-full object-contain"
        loading="lazy"
      />
    } @else {
      <span class="text-sm text-gray-400">No logo available</span>
    }
  </a>

  <!-- Body -->
  <div class="flex flex-col flex-1 p-2 md:p-4 text-center">

    <!-- Company Name -->
    <a
      [routerLink]="['/companies', slug()]"
      class="no-underline"
    >
      <h2 class="text-lg font-semibold leading-snug text-gray-900 mb-2.5 mt-0">
        {{ company().name }}
      </h2>
    </a>

    <!-- Profile Snippet -->
    @if (profileSnippet()) {
      <p class="text-sm text-gray-500 leading-relaxed mb-4 mt-0">
        {{ profileSnippet() }}
      </p>
    } @else {
      <div class="mb-4">&nbsp;</div>
    }

    <!-- Action Buttons -->
    <div class="flex flex-col md:flex-row justify-between items-center gap-2.5 mt-auto">
      @if (phone()) {
        <a
          [href]="'tel:' + phoneHref()"
          mat-stroked-button
          class="w-full md:flex-1 whitespace-nowrap p-2 md:p-0"
        >
          {{ phone() }}
        </a>
      }
      <a
        [routerLink]="['/companies', slug()]"
        mat-stroked-button
        class=" w-full md:flex-1 p-2 md:p-0"
      >
        View
      </a>

      

    </div>
  </div>
</div>
